import type {
  AppJournalEntry,
  JournalDirection,
} from "@/vybe-trader-client/messaging/stores/useJournalStore";

export function getEntryType(entry: AppJournalEntry): string {
  return entry.messageType ?? entry.category;
}

export function getEntryDirection(entry: AppJournalEntry): JournalDirection {
  return entry.direction ?? "system";
}

export function directionGlyph(direction: JournalDirection): string {
  if (direction === "in") return "←";
  if (direction === "out") return "→";
  return "·";
}

export function formatJournalTrimmedPayload(entry: AppJournalEntry): string {
  return entry.detail ?? "";
}

export function formatLogTime(timestamp: number): string {
  const date = new Date(timestamp);
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const ms = date.getMilliseconds().toString().padStart(3, "0");
  return `${hours}:${minutes}:${seconds}.${ms}`;
}

/** Single-line copy matching on-screen columns (trimmed payload only). */
export function buildJournalCopyText(entry: AppJournalEntry): string {
  const parts = [
    formatLogTime(entry.timestamp),
    directionGlyph(getEntryDirection(entry)),
    getEntryType(entry),
    entry.message,
  ];
  const payload = formatJournalTrimmedPayload(entry);
  if (payload) parts.push(payload);
  return parts.join("\t");
}

export function journalEntrySearchHaystack(entry: AppJournalEntry): string {
  return [
    entry.message,
    entry.category,
    entry.messageType ?? "",
    entry.direction ?? "",
    entry.level,
    entry.detail ?? "",
  ]
    .join(" ")
    .toLowerCase();
}
